<template>
<div class="select-style">
    <select v-model="selectSpec" @change="changeSpec">
        <option :value="spec.id" v-for="(spec, index) in specLists">{{ spec.title }}</option>
    </select>
</div>
</template>

<script>
export default {
    props: {
        row: String,
        select: Number,
        specs: Array
    },

    data() {
        return {
            selectSpec: null,
            specLists: []
        }
    },

    mounted() {
        this.selectSpec = this.select;
        this.specLists = this.specs;
    },

    methods: {
        changeSpec() {
            eventHub.$emit('updateSpec', {row: this.row, specId: this.selectSpec});
        }
    }
}
</script>
